// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width: 767px){.HomePage{margin-top:var(--header-height)}}@media (max-width: 767px){.HomePage .CmsPage{margin-top:0}}.HomePage h1{text-align:center;font-size:24px;margin-top:50px;font-weight:400;padding:0 var(--layout-lateral)}@media (min-width: 768px){.HomePage h1{margin-top:95px}}\n", ""]);
// Exports
module.exports = exports;
